import { alpha } from '@mui/material';

export const colors = {
  // Base colors
  primary: '#75F9FB',
  secondary: '#C3FFFB',
  white: '#FFFFFF',
  black: '#000000',

  // Background colors big sections
  darkGrey1: '#010104',
  darkGrey2: '#121419',
  darkGrey3: '#152428',
  darkGrey4: '#0E1719',
  lightGrey7: '#F8F8F8',

  // gallery overlay
  shallowPrimary: '#2AFCFF3B',
  shallowGrey1: '#1524273B',
  shallowGrey2: '#121c1f8c',

  // background colors smaller sections
  darkGrey5: '#121C1F',
  darkGrey6: '#070E11',
  darkGrey7: '#071718',
  darkGrey8: '#162729',

  // Status background colors
  darkRed1: '#2F0606',
  darkGreen: '#062F2F',

  // status colors
  green: '#01EBA1',
  red: '#F04248',
  yellow: '#FFD21E',
  lightBlue: '#01EBD3',

  // disabled icons
  darkPrimary: '#23383A',

  // texts
  lightGrey1: '#CBCBCB',
  lightGrey2: '#70767E',
  lightGrey3: '#F9F8FA',
  lightGrey4: '#2552544d', // label not selected ???
  lightPink: '#FFF7F7',
  lightRed: '#FF7A7A',
  grey: '#435B5D',
  darkGrey9: '#141414',
  darkerPrimary: '#00A7AC',
  lightGrey6: '#717F8E',

  // border
  lightGrey5: '#757E8C',
  shallowRed: '#FF00004D',
  shallowYellow: '#FFF8504D',
  shallowGreen: '#26FF2E4D',
  shallowBlue: '#7DFFF74D',

  // button backgrounds
  cream: alpha('#841519', 0.3),

  // bounding boxes
  yellowVivid: '#FFE100',
  redVivid: '#FF3300',
  darkBlue: '#0A2828',
  darkRed2: '#440D0A',
};

export const gradients = {
  gradientD: 'linear-gradient(180deg, #00EFD1 0%, #00ACEA 100%)', // icons messages
  tableRow:
    'transparent linear-gradient(270deg, #010104 0%, #010104 14%, #08A6AA5C 47%, #010104 80%, #010104 100%) 0% 0% no-repeat padding-box',
  patientList:
    'transparent linear-gradient(90deg, #010104 0%, #08A6AA5C 25%, #08A6AA5C 75%, #010104 100%) 0% 0% no-repeat padding-box',
  dropzone:
    'transparent linear-gradient(180deg, #010104 0%, #0A0A0D 38%, #161619 100%, #2B2C2E 100%) 0% 0% no-repeat padding-box',
  studyManager:
    'transparent linear-gradient(180deg, #010104 0%, #0A0A0D 25%, #161619 100%, #2B2C2E 100%) 0% 0% no-repeat padding-box',
  priorityHigh:
    'linear-gradient(318.41deg, rgba(255, 0, 0, 0.75) -12.31%, rgba(25, 24, 11, 0) 97.92%)',
  priorityMedium:
    'linear-gradient(318.41deg, rgba(255, 248, 80, 0.75) -12.31%, rgba(25, 24, 11, 0) 97.92%)',
  priorityLow:
    'linear-gradient(318.41deg, rgba(38, 255, 46, 0.75) -12.31%, rgba(25, 24, 11, 0) 97.92%)',
  benign:
    'linear-gradient(318.41deg, #7DFFF7 -12.31%, rgba(25, 24, 11, 0) 97.92%)',
  placeholder:
    "url('/static/svgs/media-placeholder.svg'), radial-gradient(50% 50% at 50% 50%, #3C404B 0%, #0B0D0D 100%)",
  buttonsBorder:
    'linear-gradient(180deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)',
};

export const pdfPalette = {
  primary: colors.darkerPrimary,
  background: colors.lightGrey7,
  box: {
    highlight: colors.darkGrey1,
    danger: colors.darkRed2,
  },
  text: {
    primary: colors.darkGrey9,
    secondary: colors.lightGrey6,
    footer: colors.white,
  },
};

export const toastColors = {
  // status colors
  success: colors.green,
  error: colors.red,
  warning: colors.yellow,
  info: colors.lightBlue,

  // Status gradient bases
  successGradientBase: alpha(colors.green, 0.12),
  errorGradientBase: alpha(colors.red, 0.13),
  warningGradientBase: alpha(colors.yellow, 0.11),
  infoGradientBase: alpha(colors.lightBlue, 0.11),
};
